import { useEffect } from 'react';
import { kstDay, type TrackEvent } from '@tarot/shared';

/**
 * 이용 통계 수집 (개인정보 無 — 이벤트명만 전송, 설계서 doc/analytics.md)
 * sendBeacon 우선(페이지 이탈에도 안전), 미지원 시 keepalive fetch. 실패는 조용히 무시.
 */
/**
 * 다른 API 호출과 **같은 base**를 봐야 한다. 여기만 `/api`로 박혀 있었더니,
 * 미니앱(토스 도메인에서 실행)에서는 토스 오리진으로 쏘아 통계가 통째로 사라졌다
 * (2026-08-26 코드리뷰에서 발견).
 */
const TRACK_URL = `${import.meta.env.VITE_API_BASE ?? '/api'}/track`;
/** 하루 1회 방문 집계용 localStorage 키 */
const VISIT_KEY = 'tw:lastVisitDay';

export function track(event: TrackEvent): void {
  try {
    const body = JSON.stringify({ event });
    /**
     * sendBeacon은 **같은 오리진일 때만** 쓴다. 교차 오리진(미니앱)에서 JSON Blob을 보내면
     * 프리플라이트가 필요한데 beacon은 그걸 못 해 조용히 실패한다.
     * `sendBeacon`이 false를 돌려주는 경우도 있어(큐 초과), 그때도 fetch로 넘어간다.
     */
    const sameOrigin = TRACK_URL.startsWith('/');
    if (
      sameOrigin &&
      navigator.sendBeacon?.(TRACK_URL, new Blob([body], { type: 'application/json' }))
    ) {
      return;
    }
    {
      void fetch(TRACK_URL, {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body,
        keepalive: true,
      }).catch(() => {});
    }
  } catch {
    // 통계는 부가 기능 — 어떤 실패도 서비스에 영향 주지 않음
  }
}

/** 화면 진입(마운트) 시 1회 집계 — 페이지 컴포넌트 상단에서 사용 */
export function useTrack(event: TrackEvent): void {
  useEffect(() => {
    track(event);
  }, [event]);
}

/** 하루 1회만 'visit:daily' 전송 (기기 식별 없이 브라우저 로컬 기준) */
export function trackDailyVisit(): void {
  try {
    const today = kstDay();
    if (localStorage.getItem(VISIT_KEY) === today) return;
    localStorage.setItem(VISIT_KEY, today);
  } catch {
    // localStorage 불가(시크릿 모드 등) → 그냥 매번 전송하지 않고 스킵
    return;
  }
  track('visit:daily');
}
